import styled from 'styled-components';
import { PiuProductState } from '@upright/common/model/input/companies/products/product-input-ui/types';
import { ProductSelector } from '../table/product-selector';

interface MatchingSectionProps {
  product: PiuProductState;
  onProductUpdate: (product: PiuProductState) => void;
}

export function MatchingSection({ product, onProductUpdate }: MatchingSectionProps) {
  const onProductSelect = (productCode: string, productTitle: string) => {
    const currentMatch = product.productMatchResult!;
    const isManuallyOverridden = product.autoMatchedProductCode !== productCode;
    const updatedProduct: PiuProductState = {
      ...product,
      autoMatchedProductCode: product.autoMatchedProductCode || currentMatch.productCode,
      manualOverrideTimestamp: isManuallyOverridden ? new Date().toISOString() : undefined,
      isManuallyOverridden,
      productMatchResult: {
        ...currentMatch,
        productCode,
        bestChoice: productTitle,
      },
    };
    onProductUpdate(updatedProduct);
  };

  return (
    <Container>
      <Fields>
        <FieldValuePair title="Normalized name" value={product.normalizedName} />
        <FieldValuePairContainer>
          <Field>Matched product</Field>
          <ProductSelector product={product} onProductSelect={onProductSelect} showProductCode={true} />
        </FieldValuePairContainer>
        <FieldValuePair title="Automatched product" value={product.autoMatchedProductCode} />
        <FieldValuePair title="Confidence" value={product.productMatchResult?.confidence} />
      </Fields>
    </Container>
  );
}

interface FieldValuePairProps {
  title: React.ReactNode;
  value: React.ReactNode | undefined;
}

function FieldValuePair({ title: field, value }: FieldValuePairProps) {
  return (
    <FieldValuePairContainer>
      <Field>{field}</Field>
      <Value>{value ? value : 'N/A'}</Value>
    </FieldValuePairContainer>
  );
}

const Container = styled.div`
  padding: 0 var(--space__lg);
`;

const Fields = styled.div`
  font-size: var(--font-size__md);
  display: flex;
  flex-direction: column;
  gap: var(--space__xs);
`;

const FieldValuePairContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space__sm);
`;

const Field = styled.div`
  font-weight: 500;
  color: var(--fgColor-default);
  min-width: 12em;
`;

const Value = styled.div`
  font-weight: 400;
  color: var(--fgColor-default);
`;
